module.exports = "<div class=\"col-md-12\">\r\n    <div [hidden]=\"!showSpinner\">\r\n        <app-spinner></app-spinner>\r\n    </div>\r\n    <div class=\"row\">\r\n        <iframe (load)=\"loaded()\" class=\"ser-file-manager\" [ngClass]=\"isFullpage ? 'fullpage': 'modalpage'\" id=\"iframe\" [src]=\"link | safe\"></iframe>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/file-manager/file-manager.component.html
// module id = ./src/app/components/file-manager/file-manager.component.html
// module chunks = main